export const icon_name = {
    "WINDOWS_SERVER" : 'windows',
    "VMWARE_VM_HOST" : 'server',
    "VMWARE_VM_GUEST" : 'window restore outline',
    "LINUX_SERVER" : 'linux',
    "LINUX_WORKSTATION" : 'linux',
    "WINDOWS_WORKSTATION" : 'desktop',
    "NMS_OTHER" : 'globe',
    "NMS_FIREWALL" : 'fire',
    "NMS_PRIVATE_NETWORK_GATEWAY" : 'upload',
    "NMS_NETWORK_MANAGEMENT_AGENT" : 'hdd outline',
    "switch" : 'boxes'
}

export const icon_color = {
    'false' : 'green',
    'true' : 'red'
}

export const icon_title = {
    "WINDOWS_SERVER" : 'Windows Server',
    "VMWARE_VM_HOST" : 'VMWare Host',
    "VMWARE_VM_GUEST" : 'VMWare Guest',
    "LINUX_SERVER" : 'Linux Server',
    "LINUX_WORKSTATION" : 'Linux Server',
    "WINDOWS_WORKSTATION" : 'Windows Workstation',
    "NMS_OTHER" : 'Network Device',
    "NMS_FIREWALL" : 'Firewal',
    "NMS_PRIVATE_NETWORK_GATEWAY" : 'Private Ntwork Gateway',
    "NMS_NETWORK_MANAGEMENT_AGENT" : 'Network Monitoring Agent'
}

export const net_icon_name ={
    "Ethernet 802.3" : 'sitemap',
    "Wireless" : 'wi-fi'
}

export const net_icon_color = {
    'Up' : 'green',
    'Down' : 'orange'
}

export const severity_color = {
    4: "yellow",
    3: "yellow",
    2: "orange",
    1: "red"
}